<template>
    <v-card>
       <molho v-if="molho_com"
       v-on:close_molho="close_molho_dialog"
       v-on:get_id_mol_dbl="get_id_mol_dbl"
       v-on:get_id_mol_enter="get_id_mol_enter"
       ></molho>
       <v-card-title class="text-h5">
        Возврат товара с магазина на склад
         <v-divider
           class="mx-4"
           inset
           vertical
           ></v-divider>
           <v-btn
           color="primary"
           @click="open_molho"
           >Поиск
           <v-icon>mdi-magnify</v-icon>
           </v-btn>

           <v-divider
           class="mx-4"
           inset
           vertical
           ></v-divider>
           <v-btn
           color="success"
           @click="save_moving"
           :disabled="!mol.length"
           >Сохранить

           </v-btn>

         <v-spacer></v-spacer>

       </v-card-title>
       <v-card-text>

         <v-data-table
           :headers="headers"
           :items="mol"
           :search="search"
           class="elevation-1"
           :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
         >

         <template v-slot:item.mikdor="props">
           <v-edit-dialog
           :return-value.sync="props.item.mikdor"
             large
             persistent

             cancel-text="Отмена"
             save-text="Сохранить"
           >
             <div>{{  parseFloat(props.item.mikdor) }}</div>
             <template v-slot:input>

               <v-text-field
               @focus="$event.target.select()"
               v-model="props.item.mikdor"
               :rules="mikdorRules"
               label="Количество"
               single-line
                 counter
                 autofocus

               ></v-text-field>
             </template>

           </v-edit-dialog>
         </template>



           <template v-slot:item.actions="{ item }">
             <v-icon
               small
               class="mr-2"
               @click="delete_mol(item)"
             >
               mdi-delete
             </v-icon>
           </template>



         </v-data-table>
       </v-card-text>

       <v-snackbar
       v-model="snack"
       :timeout="3000"
       :color="snackColor"
     >
       {{ snackText }}

       <template v-slot:action="{ attrs }">
         <v-btn
           v-bind="attrs"
           text
           @click="snack = false"
         >
           Закрыть
         </v-btn>
       </template>
     </v-snackbar>

    </v-card>
   </template>

   <script>
   export default {

       data() {
           return {
               search: '',
               snack: false,
               snackColor: '',
               snackText: '',
               molho_com:false,
                loading: false,
               mikdorRules:[
               v => !!v || 'Обязательное поле',
               v=> (v && /[0-9]/.test(v)) || 'Неверный формат ввода',
               v => (v && /^\d*\.?\d*$/.test(v)) || 'Неверный формат ввода',
         ],

               headers: [
                   {
                       text: 'Код',
                       align: 'start',
                       sortable: false,
                       value: 'kod',
                   },
                   { text: 'Наименование', value: 'nom' },
                   { text: 'Закуп.цена', value: 'narkhi_a' },
                   { text: 'Количество', value: 'mikdor' },
                   { text: 'Действия', value: 'actions' },
                   { text: 'id_mol', value: 'id_mol',  align: ' d-none' },
               ],
               mol:  [],

           }
       },

       methods:{
           open_molho(){
               this.molho_com = true;
           },
           close_molho_dialog(){
               this.molho_com = false;
           },

           get_id_mol_dbl(id){
               this.loading = true;
                 axios.get('/api/get_id_mol/' + id,
                         {
                             headers: {
                                 "Content-type": "application/json"
                             }
                         })
                         .then(response => {
                                 if(response.data.status){
                                     this.loading = false;
                                     this.mol.push(response.data.mol);
                                     this.close_molho_dialog();
                                 }else{
                                     this.loading = false;
                                     this.snack = true
                                     this.snackColor = 'error'
                                     this.snackText = "Ошибка получения клиентов"
                                     setTimeout(() => {
                                         this.snack = false;
                                     }, 2000);
                                 }
                             })
                             .catch(error => {
                                 this.loading = false;
                                 this.snack = true
                                 this.snackColor = 'error'
                                 this.snackText = error.response.data.message;
                                     setTimeout(() => {
                                         this.snack = false;
                                     }, 2000);
                             });
           },
           get_id_mol_enter(id){
               this.loading = true;
                 axios.get('/api/get_kod/' + id,
                         {
                             headers: {
                                 "Content-type": "application/json"
                             }
                         })
                         .then(response => {
                                 if(response.data.status){
                                     this.loading = false;
                                     this.mol.push(response.data.mol);
                                     this.close_molho_dialog();

                                 }else{
                                     this.loading = false;
                                     this.snack = true
                                     this.snackColor = 'error'
                                     this.snackText = "Ошибка получения клиентов"
                                     setTimeout(() => {
                                         this.snack = false;
                                     }, 2000);
                                 }
                             })
                             .catch(error => {
                                 this.loading = false;
                                 this.snack = true
                                 this.snackColor = 'error'
                                 this.snackText = error.response.data.message;
                                 console.log(error.response.data.message);
                                     setTimeout(() => {
                                         this.snack = false;
                                     }, 2000);
                             });
           },

           save_moving(){
               this.loading = true;
               this.$session.start();
               var id_user = this.$session.get('id_user');
                 axios.post('/api/save_moving/1/2/' + id_user,  {molho: this.mol},
                         {
                             headers: {
                                 "Content-type": "application/json"
                             }
                         })
                         .then(response => {
                                 if(response.data.status){
                                     this.loading = false;
                                       this.snack = true
                                       this.snackColor = 'success'
                                       this.snackText = "Данные успешно сохранены"
                                       this.mol = [];
                                       this.mol.splice(0, this.mol.length);
                                       console.log(response.data.message);

                                 }else{
                                     this.loading = false;
                                     this.snack = true
                                     this.snackColor = 'error'
                                     this.snackText = "Ошибка получения клиентов"
                                     setTimeout(() => {
                                         this.snack = false;
                                     }, 2000);
                                 }
                             })
                             .catch(error => {
                                 this.loading = false;
                                 this.snack = true
                                 this.snackColor = 'error'
                                 this.snackText = error.response.data.message;
                                 console.log(error.response.data.message);
                                     setTimeout(() => {
                                         this.snack = false;
                                     }, 2000);
                             });
           },

           delete_mol(item){
               this.mol.splice(this.mol.indexOf(item), 1);

           }

       }

   }
   </script>

   <style>

   </style>





